import { Injectable } from '@angular/core';
import {
    Router, Resolve,
    RouterStateSnapshot,
    ActivatedRouteSnapshot
} from '@angular/router';
import { combineLatest, forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse } from '../interfaces/api-response';
import { SharedDirectoryService } from '../services/api/shared-directory.service';

@Injectable({
    providedIn: 'root'
})
export class DirectoryResolver implements Resolve<ApiResponse[]> {

    constructor(private sharedDirectoryService: SharedDirectoryService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ApiResponse[]> {
        let shared = this.sharedDirectoryService.getShared();
        let access = this.sharedDirectoryService.getAccess();
        return forkJoin(shared,access);
    }
}
